import getConfig from 'next/config'
import fetch from 'isomorphic-unfetch'

import { fetchList } from './utils'

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()

const getSingleArtistUrl = '/api/v1/artists/'

export const fetchArtists = (page, filters, limit, language, token) => {
  if (filters.artist__genres && !filters.genres) {
    if (filters.artist__genres.includes('headliner'))
      filters.headliner = true

    filters.genres = filters.artist__genres.filter(x => x !== 'headliner')
    filters.artist__genres = null
  }

  return fetchList(page, filters, 'artists', limit, language, token)
} // eslint-disable-line

export const fetchSingleArtist = async ({ id }, language, userToken) => {
  const token = userToken
  let url = getSingleArtistUrl
  if (serverRuntimeConfig && serverRuntimeConfig.serverAddress) {
    url = `${serverRuntimeConfig.serverAddress}${url}`
  }

  if (id) {
    url = `${url}${id}/`
  }

  try {
    const headers = {
      Authorization: token ? `JWT ${token}` : undefined,
      Accept: 'application/json',
      'Accept-language': language,
      Secret: publicRuntimeConfig.secret
    }

    const res = await fetch(url, {
      headers
    })

    const artistJson = await res.json()
    if (artistJson && artistJson.id) return artistJson
  } catch (error) {
    console.error(error)
  }
  return null
}
